import React from 'react';

interface WidgetEmptyStateProps {
  /** Icon element displayed in the circle */
  icon?: React.ReactNode;
  /** Primary message */
  title: string;
  /** Optional secondary description */
  description?: string;
  /** Optional action element (button, link, etc.) */
  action?: React.ReactNode;
  className?: string;
}

const WidgetEmptyState: React.FC<WidgetEmptyStateProps> = ({
  icon,
  title,
  description,
  action,
  className = '',
}) => (
  <div className={`h-full flex items-center justify-center p-6 ${className}`}>
    <div className="text-center max-w-xs">
      {icon && (
        <div className="w-14 h-14 mx-auto mb-4 rounded-xl bg-neutral-100 flex items-center justify-center text-neutral-400 text-2xl">
          {icon}
        </div>
      )}
      <p className="font-semibold text-neutral-700 text-sm">{title}</p>
      {description && <p className="text-xs text-neutral-500 mt-1">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  </div>
);

export default WidgetEmptyState;
